import React from 'react';
import { compose, withHandlers, lifecycle, mapProps } from 'recompose';
import { HTMLTrans } from '../../Common/Translations';
import { sendEmailVerification } from '../../Common/Providers/VerifyEmailApi';
import camelize from 'camelize';

const UserVerification = ({ getData, sendEmailVerificationApi, ...props }) => {
  return (
    <div className="container my-5">
      <div className='container-fluid'>
        <div className="row col">
          <h5><b><HTMLTrans id='ephotobook.privacy_title'>We want to protect your privacy</HTMLTrans></b></h5><br/>
          <p>
            <HTMLTrans id='ephotobook.privacy_content' variables={{"email": props.userDetail.email}}>
              In order to use Share It, your email needs to be verified. An email has been sent to your registered email account <span className="not-found__error-title"><b>{props.userDetail.email}</b></span>. Please check the email we just sent and click on the link to proceed.
            </HTMLTrans>
          </p>
          <br/><br/>
          {props.ephotobookDetails.userVerification.allowResend &&
          <a className="not-found__error-title" href='#' onClick={sendEmailVerificationApi}><HTMLTrans id='ephotobook.send_verification_email'>Send verification email again</HTMLTrans></a>
          }
        </div>
      </div>
    </div>
  );
}

const enhance = compose(
  withHandlers({
    sendEmailVerificationApi: (props) => () => {
      const payload = {
        redirect_url: props.ephotobookDetails.url.link,
      };
      sendEmailVerification(payload)
        .done(response => toastr.success(props.t('ephotobook.success_send_email_verification', 'Verification email sent!')))
        .fail(response => toastr.error(props.t('ephotobook.fail_send_email_verification', 'Verification email not sent. Something went wrong, please try again.')));
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        ephotobookDetails: {
          userVerification: {
            allowResend,
            requestedEmailVerification,
          },
          url: {
            link,
          }
        } = {}
      } = this.props;

      if (!requestedEmailVerification) {
        this.props.sendEmailVerificationApi(this.props);
      }
    }
  }),
  mapProps(({ ephotobookDetails, ...props }) => ({
    ephotobookDetails: camelize(ephotobookDetails),
    ...props,
  })),
);

export default enhance(UserVerification);
export const undecorated = UserVerification;



// WEBPACK FOOTER //
// ./src/Account/EPhotobook/UserVerification.js